// extracted by mini-css-extract-plugin
export default {"block":"purpose_block__Atn10","item":"purpose_item__FSLNY","checked":"purpose_checked__zOWKf","desc":"purpose_desc__x34ij","actions":"purpose_actions__h+p7D"};